<template>
    <div class="menuManagement">
      <breadcrumb class="breadcrumb"/>
      <el-row class="main-container">
        <!--左侧栏菜单-->
        <el-col :span="8" class="menuLeft">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>菜单列表</span>
            </div>
            <div style="min-height: 710px">
              <div class="treeOption">
                <el-button type="success" size="small" icon="el-icon-plus" @click="addMenu">新增</el-button>
                <el-button type="warning" size="small" icon="el-icon-edit" @click="modifyMenu">修改</el-button>
                <el-button type="danger" size="small" icon="el-icon-delete" @click="deleteMenu">删除</el-button>
              </div>
              <div style="height: 631px;overflow-y: auto">
                <el-tree :data="treeData" :props="treeProps" lazy :load="loadSecondary" :highlight-current="true" @node-click="nodeClick" :expand-on-click-node="false" style="min-height: 631px">

                </el-tree>
              </div>
              <el-pagination
                @current-change="menuCurrentChange"
                :page-size="10"
                layout="prev, pager, next, jumper"
                :total="menuTotal">
              </el-pagination>
            </div>
          </el-card>
        </el-col>

        <!--右侧栏菜单-->
        <el-col :span="16" class="menuRight">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>接口列表</span>
            </div>
            <div style="min-height: 710px">
              <el-row class="interfaceOption">
                <el-col :span="10">
                  <el-input v-model="interfaceSearch" placeholder="请输入接口名称" clearable prefix-icon="el-icon-search" size="small" @keydown.native="portSearch"></el-input>
                </el-col>

                <el-col :offset="2" :span="11">
                  <el-button type="success" size="small" icon="el-icon-plus" @click="addPort">新增</el-button>
                  <el-button type="warning" size="small" icon="el-icon-edit" @click="modifyPort">修改</el-button>
                  <el-button type="danger" size="small" icon="el-icon-delete" @click="deletePort">删除</el-button>
                </el-col>
              </el-row>

              <div style="margin-top: 15px">
                <div style="height: 631px;overflow-y: auto">
                  <el-table
                    :data="portData"
                    style="width: 100%;min-height: 631px"
                    v-loading="portLoad" :stripe="true" :border="true"
                    highlight-current-row @current-change="portListChange">
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60">
                    </el-table-column>
                    <el-table-column
                      prop="interfaceName"
                      label="接口名称">
                    </el-table-column>
                    <el-table-column
                      prop="interfaceUrl"
                      label="接口URL"
                      width="300">
                    </el-table-column>
                    <el-table-column
                      prop="interfaceDesc"
                      label="接口描述">
                    </el-table-column>
                    <el-table-column
                      prop="rownumber"
                      width="100"
                      label="创建人">
                    </el-table-column>
                    <el-table-column
                      prop="date"
                      label="创建时间">
                    </el-table-column>
                  </el-table>
                </div>
                <el-pagination
                  @current-change="portCurrentChange"
                  :page-size="10"
                  layout="prev, pager, next, jumper"
                  :total="menuTotal">
                </el-pagination>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!--菜单dialog-->
      <el-dialog
        :title="menuTitleName"
        :visible.sync="dialogAddChange"
        width="500px">
        <div>
          <el-form ref="form" :model="formResult" label-width="100px" :rules="menuRules">
            <el-form-item label="菜单名称：">
              <el-input v-model="formResult.menuName"></el-input>
            </el-form-item>
            <el-form-item label="菜单路径：">
              <el-input v-model="formResult.menuUrl"></el-input>
            </el-form-item>
            <el-form-item label="父级节点：" v-show="parentIDModify">
              <el-input v-model="formResult.parentMenuName" disabled></el-input>
            </el-form-item>
            <el-form-item label="图标：">
              <el-input v-model="formResult.menuIcon"></el-input>
            </el-form-item>
            <el-form-item label="序号">
              <el-input v-model="formResult.menuSerial"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="formResult.description" type="textarea" maxlength="50"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="dialogAddChange = false">取 消</el-button>
    <el-button type="primary" @click="submitMenu">确 定</el-button>
  </span>
      </el-dialog>
      <!--接口dialog-->
      <el-dialog
        :title="addPortBool?'+新增接口':'修改接口'"
        :visible.sync="dialogPort"
        width="500px">
        <div>
          <el-form ref="portForm" :model="portResult" label-width="100px" :rules="portRules">
            <el-form-item label="接口名称：">
              <el-input v-model="portResult.interfaceName"></el-input>
            </el-form-item>
            <el-form-item label="接口路径：">
              <el-input v-model="portResult.interfaceUrl"></el-input>
            </el-form-item>
            <el-form-item label="接口描述：">
              <el-input v-model="portResult.interfaceDesc"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="dialogAddChange = false">取 消</el-button>
    <el-button type="primary" @click="submitPort">确 定</el-button>
  </span>
      </el-dialog>
    </div>
</template>

<script>
  import moment from 'moment'
	export default {
		data() {
		  let validateMenuName = (rule, value, callback)=>{
		    if(!value){
          return callback(new Error('菜单名称不能为空'));
        }else{
          callback();
        }
      }
      let validateInterfaceName = (rule, value, callback)=>{
        if(!value){
          return callback(new Error('菜单名称不能为空'));
        }else{
          callback();
        }
      }
      let validateInterfaceUrl = (rule, value, callback)=>{
        if(!value){
          return callback(new Error('菜单名称不能为空'));
        }else{
          callback();
        }
      }
			return {
        pageSize:10,
        pageNo:1,
        treeData:[],
        dialogAddChange:false,
        menuTitleName:'',
        dialogPort:false,
        parentMenu:{},
        interfaceSearch:'',
        portData:[],
        menuTotal:0,
        portTotal:0,
        currentPage3:'',
        portPageNo:1,
        portLoad:false,
        portObj:{},
        parentIDModify:false,
        addPortBool:false,
        formResult:{menuName:'',menuIcon:'',menuUrl:'',menuSerial:'',description:'',parentMenuName:''},
        portResult:{interfaceName:'',interfaceUrl:'',interfaceDesc:''},
        treeProps:{
          children: 'childMenus',
          label: 'menuName',
        },
        menuRules:{
          menuName:[ { validator: validateMenuName, trigger: 'blur',required: true }]
        },
        portRules:{
          interfaceName:[{ validator: validateInterfaceName, trigger: 'blur',required: true }],
          interfaceUrl:[{ validator: validateInterfaceUrl, trigger: 'blur',required: true }]
        }
      }
		},
    mounted(){
		  this.init();
    },
		methods: {
			// 初始化
			init() {
				let vm = this;
        vm.queryAllParentMenus();
			},
      //获取所有菜单
      queryAllParentMenus(obj){
			  let vm =this;
        let params = {
          pageSize:vm.pageSize,
          pageNo:vm.pageNo,
        }
			  //console.log(obj)
        vm.axios.get("/common/queryAllParentMenus", {params: params})
          .then((res)=> {
            vm.treeData = res.data.allMenus;
            vm.menuTotal = res.data.count[0].count;
            console.log(res.data)
            for(let val of vm.treeData){
              val.childMenus = [];
            }
          })
      },
      //加载子树数据的方法
      loadSecondary(node,resolve){
        //console.log(node)
        //console.log(resolve)
        let vm = this;
        vm.axios.get("/common/queryChildMenuByParentId", {params: {parentMenuId: node.data.ID}})
          .then((res)=> {
          if(res.data.childMenus){
            resolve(res.data.childMenus);
          }
          })
      },
      //新增菜单
      addMenu(){
        let vm =this;
        vm.formResult.menuName ='';
        vm.formResult.menuIcon = '';
        vm.formResult.menuUrl = '';
        vm.formResult.menuSerial = '';
        vm.formResult.description = '';
        vm.formResult.parentMenuId = '';
        vm.formResult.ID  = '';
        vm.parentIDModify = true;
        vm.menuTitleName = '+新增菜单'
        if(JSON.stringify(vm.parentMenu)!=='{}'){
          vm.formResult.parentMenuName = vm.parentMenu.menuName;
        }else{
          vm.formResult.parentMenuName = '一级目录无父节点'
        }
        vm.dialogAddChange = true;
      },
      //修改菜单
      modifyMenu(){
        let vm = this;
        vm.parentIDModify = false;
        vm.menuTitleName = '修改菜单'
        console.log(vm.parentMenu);
        vm.formResult.menuName = vm.parentMenu.menuName;
        vm.formResult.menuIcon = vm.parentMenu.menuIcon;
        vm.formResult.menuUrl = vm.parentMenu.menuUrl || '';
        vm.formResult.menuSerial = vm.parentMenu.menuSerial;
        vm.formResult.description = vm.parentMenu.description;
        vm.formResult.parentMenuId = vm.parentMenu.parentMenuId;
        vm.formResult.ID  = vm.parentMenu.ID;
        vm.dialogAddChange = true;
      },
      //删除菜单
      deleteMenu(){
        let vm =this;
        vm.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ID:vm.parentMenu.ID
          }
          vm.axios.post("/common/deleteMenu", {params: params})
            .then((res)=> {
              console.log(res)
              if(res.data.resultCode === '00'){
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                vm.init();
              }
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //菜单提交
      submitMenu(){
        let vm =this;
        if(vm.parentIDModify){
          let params = {};
          params.menuName = vm.formResult.menuName;
          params.menuIcon = vm.formResult.menuIcon;
          params.menuUrl = vm.formResult.menuUrl || null;
          params.menuSerial = vm.formResult.menuSerial;
          params.description = vm.formResult.description;
          params.parentMenuId = vm.parentMenu.ID || null;
          console.log(params);
          vm.axios.post("/common/saveMenu", {params: params})
            .then((res)=> {
              console.log(res)
              if(res.data.resultCode === '00'){
                vm.init();
                vm.dialogAddChange = false;
                for(let key in vm.formResult){
                  vm.formResult[key] = ''
                }
              }
            })
        } else{
          let params = {
            menuName:vm.formResult.menuName,
            menuIcon:vm.formResult.menuIcon,
            menuUrl:vm.formResult.menuUrl,
            menuSerial:vm.formResult.menuSerial,
            description:vm.formResult.description,
            parentMenuId:vm.formResult.parentMenuId,
            ID:vm.formResult.ID,
          }
          console.log(params)
          vm.axios.post("/common/modifyMenu", {params: params})
            .then((res)=> {
              console.log(res)
              if(res.data.resultCode === '00'){
                vm.init();
                vm.dialogAddChange = false;
                for(let key in vm.formResult){
                  vm.formResult[key] = ''
                }
              }
            })
        }
      },
      //接口搜索
      portSearch(){
        let vm =this;
        let params = {
          pageSize:10,
          pageNo:vm.portPageNo,
          interfaceName:vm.interfaceSearch,
          menuId:vm.parentMenu.ID,
        }
        vm.queryPortList(params);
      },
      //新增接口
      addPort(){
        let vm = this;
        if(!vm.parentMenu.ID){
          this.$message({
            type: 'error',
            message: '请选择一项菜单!'
          });
        }else{
          this.addPortBool = true;
          this.dialogPort = true;
        }
      },
      //修改接口
      modifyPort(){
        let vm = this;
        if(JSON.stringify(vm.portObj) === '{}'){
          this.$message({
            type: 'error',
            message: '请选择一项接口!'
          });
        }else{
          vm.portResult.interfaceName = vm.portObj.interfaceName;
          vm.portResult.interfaceUrl = vm.portObj.interfaceUrl;
          vm.portResult.interfaceDesc = vm.portObj.interfaceDesc;
          this.addPortBool = false;
          this.dialogPort = true;
        }
      },
      //删除接口
      deletePort(){
        let vm =this;
        if(JSON.stringify(vm.portObj) === '{}'){
          this.$message({
            type: 'error',
            message: '请选择一项接口!'
          });
        }else{
          vm.$confirm('此操作将永久删除该接口, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let params = {
              ID:vm.portObj.ID
            }
            console.log(params)
            vm.axios.post("/common/deleteMenuInterface", {params: params})
              .then((res)=> {
                //console.log(res)
                if(res.data.resultCode === '00'){
                  let params = {
                    pageSize:10,
                    pageNo:vm.portPageNo,
                    interfaceName:vm.interfaceSearch,
                    menuId:vm.parentMenu.ID,
                  }
                  vm.queryPortList(params);
                  vm.dialogPort = false;
                  vm.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                }
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
      //当表格的当前行发生变化的时候会触发该事件
      portListChange(currentRow, oldCurrentRow){
        let vm =this;
        vm.portObj = currentRow;
      },
      //新增接口提交事件
      submitPort(){
        let vm =this;
        vm.$refs.portForm.validate((val)=>{
          if(val){
            if(vm.addPortBool){
              let params = {
                interfaceName:vm.portResult.interfaceName,
                interfaceUrl:vm.portResult.interfaceUrl,
                interfaceDesc:vm.portResult.interfaceDesc,
                menuId:vm.parentMenu.ID
              }
              vm.axios.post("/common/saveMenuInterface", {params: params})
                .then((res)=> {
                  console.log(res)
                  if(res.data.resultCode === '00'){
                    let params = {
                      pageSize:10,
                      pageNo:vm.portPageNo,
                      interfaceName:vm.interfaceSearch,
                      menuId:vm.parentMenu.ID,
                    }
                    vm.queryPortList(params);
                    vm.$message({
                      type: 'success',
                      message: '新建接口成功!'
                    });
                    for(let key in vm.portObj){
                      vm.portObj[key] = '';
                    }
                    vm.dialogPort = false;
                  }
                })
            }else{
              let params = {
                interfaceName:vm.portResult.interfaceName,
                interfaceUrl:vm.portResult.interfaceUrl,
                interfaceDesc:vm.portResult.interfaceDesc,
                ID:vm.portObj.ID,
              }
              vm.axios.post("/common/modifyMenuInterface", {params: params})
                .then((res)=> {
                  console.log(res)
                  if(res.data.resultCode === '00'){
                    let params = {
                      pageSize:10,
                      pageNo:vm.portPageNo,
                      interfaceName:vm.interfaceSearch,
                      menuId:vm.parentMenu.ID,
                    }
                    vm.queryPortList(params);
                    vm.$message({
                      type: 'success',
                      message: '修改接口成功!'
                    });
                    for(let key in vm.portObj){
                      vm.portObj[key] = '';
                    }
                    vm.dialogPort = false;
                  }
                })
            }
          }
        })
      },
      //获取接口列表
      queryPortList(obj){
        let vm = this;
        vm.axios.get("/common/queryInterfaceByMenuId", {params:obj})
          .then((res)=> {
            vm.portData = res.data.menuInterfaces;
            vm.portTotal = res.data.count[0].count;
            if(vm.portData.length>0){
              vm.portData.forEach((val)=>{
                val.date = moment(new Date(val.createDate)).utcOffset(0).format('YYYY-MM-DD HH:mm:ss')
              })
            }
            vm.portLoad = false;
            console.log(res)
          })
      },
      //节点点击事件
      nodeClick(obj,node,self){
        let vm =this;
        if(JSON.stringify(vm.parentMenu)!== '{}'){
          if(vm.parentMenu.ID === obj.ID){
            self.$el.classList.remove('is-current');
            vm.parentMenu = {};
          }else{
            vm.parentMenu = obj;
          }
        }else{
          self.$el.classList.add('is-current');
          vm.parentMenu = obj;
        }
      },
      //菜单分页变化事件
      menuCurrentChange(val){
        let vm =this;
        vm.pageNo = val;
        vm.queryAllParentMenus();
      },
      //接口分页变化事件
      portCurrentChange(val){
        let vm =this;
        vm.portPageNo = val;
        let params = {
          pageSize:10,
          pageNo:vm.portPageNo,
          interfaceName:vm.interfaceSearch,
          menuId:vm.parentMenu.ID,
        }
        vm.queryPortList(params);
      },
		},
    watch:{
      parentMenu(val){
        console.log(val.ID)
        let vm =this;
        if(val.ID){
          vm.portLoad = true;
          let params = {
            pageSize:10,
            pageNo:vm.portPageNo,
            interfaceName:vm.interfaceSearch,
            menuId:val.ID,
          }
          console.log(params)
          vm.queryPortList(params);
        }else{
          vm.portData = [];
        }
      },
      portData(){
        let vm =this;
        vm.portObj = {};
      }
    }
	}
</script>

<style scoped lang="scss">
  .menuManagement{
    .menuLeft{
      .treeOption{
        display: flex;
        justify-content: flex-end;
        margin-bottom: 15px;
      }
    }
    .menuRight{
      padding-left: 5px;
      .interfaceOption{

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/management/menuManagement.vue